export default __webpack_public_path__ + "static/media/adminLanding.8a345e90.png";